
import { Options, Vue } from 'vue-class-component';
import NThemeImage from '@/uikit/image/NThemeImage.vue';
import PageContentLayout from '@/pages/PageContentLayout.vue';

@Options({
  name: 'PageNotFound',
  components: { NThemeImage, PageContentLayout }
})
export default class PageNotFound extends Vue {}
